module.exports = __webpack_public_path__ + "prod/20260430154405/img/url-app.d88da72d.png";